var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.VChart,{staticClass:"chart",attrs:{"option":_setup.options,"autoresize":true,"theme":_vm.$vuetify.theme.dark ? 'dark' : 'light'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }